import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  inputPlaceholder: {
    position: "absolute",
    left: 30,
  },
  add: {
    marginLeft: theme.hv.spacing.xs,
  },
}));

export default useStyles;
